import { extendTheme } from '@chakra-ui/react';

// 2. Add your color mode config
const config = {
	initialColorMode: 'dark',
	useSystemColorMode: false,
};

// 3. extend the theme
const theme = extendTheme({
	config,
	styles: {
		global: (props) => ({
			body: {
				// These are Chakra's defaults (you don't need to set them):
				bg: props.colorMode === 'dark' ? 'gray.800' : 'gray.50', // Softer than pure white
				color: props.colorMode === 'dark' ? 'whiteAlpha.900' : 'gray.800',
			},
		}),
	},
	components: {
		Accordion: {
			parts: ['container', 'item', 'button', 'panel'],
			baseStyle: (props) => ({
				container: {
					borderColor: props.colorMode === 'dark' ? 'gray.700' : 'gray.300',
				},
				button: {
					backgroundColor: props.colorMode === 'dark' ? 'gray.600' : 'gray.200',
					_hover: {
						backgroundColor: props.colorMode === 'dark' ? 'gray.500' : 'gray.200',
					},
				},
			}),
		},
	},
});

export default theme;
